import { apiGet, apiDelete } from '../helpers/ApiHelper';
import Auth from 'j-toker';
import * as notifications from './notificationActions';

export function getApplicationStatus() {
  return dispatch =>
    dispatch({
      type: 'GET_APPLICATION_STATUS',
      payload: apiGet(Auth.getApiUrl() + `/application_status`).catch(err => {
        dispatch(notifications.showFailure(err));
      }),
    });
}

export function cancelLeadApplication(application_id) {
  return dispatch =>
    apiDelete(Auth.getApiUrl() + `/cancel_application/${application_id}`)
      .done(response => {
        dispatch(notifications.showSuccess('applicationSuccessfullyCancelled'));
      })
      .catch(error => {
        console.error('request failed', error);
        dispatch(notifications.showFailure(error));
      });
}
